<div class="popup">
    <p *ngIf="success == true" class="success-popup">Saved!</p>
    <p *ngIf="success == false" class="reject-popup">Rejected!</p>
</div>

<div class="container" *ngIf="isSkeltonLoad">
    <div class="row">
        <div class="col main oldpassword" *ngFor="let item of skeltonArray">
            <form class="form-skelton">
                <div class="headingSkelton"></div>
                <div class="textSkelton"></div>
                <div class="textBoxSkelton"></div>
                <div class="textSkelton"></div>
                <div class="textBoxSkelton"></div>
                <div class="textSkelton"></div>
                <div class="textBoxSkelton"></div>
                <div class="buttonSkelton"></div>
            </form>
        </div>
    </div>
</div>
<div class="container ">
    <p *ngIf="nonEmailUser && !isSkeltonLoad" class="notify"> Oops, You can’t change your password, as you
        have logged in with {{provider}}</p>
    <!-- <p class="heading" *ngIf="!nonEmailUser && !isSkeltonLoad">Change Password</p> -->
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" *ngIf="!nonEmailUser && !isSkeltonLoad"
        [ngStyle]="{ height: windowWidth}">
        <p class="heading">Change Password</p>
        <div class="whole-wrapper">
            <div class="oldpassword">
                <label class="label">Old Password</label>
                <input class="input-text" id="input-password" type="password" formControlName="oldpassword">
                <!-- <i (click)="onClickSowPassowrd()" *ngIf="!nonEmailUser" class="fa fa-eye password-show"></i> -->
                <span class="input-text-required"
                    *ngIf="changePasswordForm.get('oldpassword').errors?.required && (changePasswordForm.get('oldpassword').dirty || changePasswordForm.get('oldpassword').touched)">
                    Field Cannot be empty<br></span>
                <span class="input-text-required"
                    *ngIf="error && changePasswordForm.controls.oldpassword.errors?.required">
                    Old Password is required </span>
            </div>
            <div class="newpassword">
                <label class="label">New Password</label>
                <input class="input-text" id="input-password" type="password" formControlName="newpassword">
                <span class="input-text-required"
                    *ngIf="changePasswordForm.get('newpassword').errors?.required && (changePasswordForm.get('newpassword').dirty || changePasswordForm.get('newpassword').touched)">
                    Field Cannot be empty<br></span>
                <span class="input-text-required"
                    *ngIf="error && changePasswordForm.controls.newpassword.errors?.required">
                    New Password is required </span>
            </div>
            <div class="reenterpassword">
                <label class="label">Re-enter Password</label>
                <input class="input-text" id="input-password" type="password" formControlName="reenterpassword">
                <span class="input-text-required"
                    *ngIf="changePasswordForm.get('reenterpassword').errors?.required && (changePasswordForm.get('reenterpassword').dirty || changePasswordForm.get('reenterpassword').touched)">
                    Field Cannot be empty<br></span>
                <span class="input-text-required"
                    *ngIf="error && changePasswordForm.controls.reenterpassword.errors?.required">
                    Re-enter Password is required </span>
                <span class="input-text-required" *ngIf="error">{{message}}</span>
            </div>
        </div>
        <div class="changepassword-div">
            <button class="changepassword" type="submit" id="submit-btn"
                [disabled]="changePasswordForm.invalid || nonEmailUser">
                <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                Change Password
            </button>
        </div>

    </form>
</div>